// extracted by mini-css-extract-plugin
export default {"newsletter__field":"newsletter__field_LKqz"};